module.exports = __webpack_public_path__ + "static/data_anaylitics-5a1a8f28e09e34e10cbc079d586952d3.png";